
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitokhandalataxi() {



    const cardData =
    {
        keyword: ' Mumbai to Khandala Taxi Fare',
        heading: 'Deva Cabs:  Mumbai to Khandala Taxi Fare',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free taxi services from Mumbai to Khandala at competitive fares. Whether you are heading up to the lush hills for a peaceful weekend, a romantic getaway, or a refreshing retreat, our professional drivers and well-maintained vehicles ensure a scenic and safe journey. Khandala, nestled in the Western Ghats, is famed for its misty hills, waterfalls, and nature trails—a perfect escape from city life. With transparent fare packages, flexible pickup and drop-off options, and a range of vehicle choices, Deva Cabs guarantees a smooth, picturesque, and cost-effective ride from Mumbai to Khandala every time.',

        top: 'Top Places to Visit in Khandala with Deva Cabs',

"topPlaces": [
  {
    "title": "Tiger’s Leap (Tiger Point)",
    "location": "Khandala, Maharashtra",
    "description": "Tiger’s Leap, also known as Tiger Point, is one of the most iconic viewpoints in Khandala. This cliff-top spot gives the illusion of a tiger leaping into the valley, hence the name. The point offers a spectacular view of the lush green Western Ghats, deep valleys, and waterfalls, especially during the monsoon season. It’s a favorite among photographers and nature lovers. Visitors can also enjoy roadside snacks while admiring the foggy, mystical ambiance during early mornings and evenings."
  },
  {
    "title": "Duke’s Nose (Nagphani)",
    "location": "Khandala, Maharashtra",
    "description": "Named after the Duke of Wellington whose nose it is said to resemble, Duke’s Nose—locally called Nagphani (Cobra’s Hood)—is a towering cliff popular for trekking, hiking, and rock climbing. The viewpoint offers breathtaking panoramic views of the surrounding Sahyadri hills and valleys. It’s especially thrilling for adventure lovers looking for rappelling or climbing activities. The peaceful environment and stunning elevation make it ideal for spiritual retreats and nature photography."
  },
  {
    "title": "Bhushi Dam & Lake",
    "location": "Lonavala–Khandala, Maharashtra",
    "description": "Bhushi Dam is a popular weekend attraction located between Lonavala and Khandala. Built on the Indrayani River, the dam overflows with cascading water during the monsoon season, forming shallow pools and rivulets perfect for splashing and soaking. Families and groups enjoy sitting on the stone steps and experiencing the refreshing flow. While swimming is restricted due to safety, the dam’s surroundings are great for picnics, chai stalls, and casual relaxation in nature."
  },
  {
    "title": "Lohagad Fort",
    "location": "Near Khandala, Maharashtra",
    "description": "Lohagad Fort, or 'Iron Fort', stands tall at 1,033 meters above sea level and is a magnificent example of Maratha military architecture. It was used by Chhatrapati Shivaji Maharaj to store treasure after capturing Surat. A trek to the fort is relatively easy and offers spectacular views of the surrounding hills, waterfalls, and Pawna Lake. The famous 'Vinchu Kata' (Scorpion’s Tail) formation at the top adds a dramatic touch to this historical landmark. It is a must-visit for both history buffs and trekking enthusiasts."
  },
  {
    "title": "Rajmachi Fort",
    "location": "Between Khandala & Lonavala, Maharashtra",
    "description": "Rajmachi Fort is a historical gem nestled between Khandala and Lonavala. The fort comprises two stronghold peaks—Shrivardhan and Manaranjan—connected by a wide plateau. It offers sweeping views of the Kondhane caves and Ulhas Valley. Trekking to Rajmachi through dense forests, muddy trails, and streams is a monsoon adventure in itself. Ideal for night treks and camping under the stars, it provides a rare blend of nature, adventure, and heritage in one trip."
  },
  {
    "title": "Bedsa & Bhaja Caves",
    "location": "Near Khandala, Maharashtra",
    "description": "The Bhaja and Bedsa Caves are ancient Buddhist rock-cut monuments dating back to the 2nd century BCE. These caves house chaityas (prayer halls), viharas (monk residences), and beautiful stupas carved into the hillsides. Bhaja Caves are particularly famous for their intricate carvings and wooden architecture that has stood the test of time. A short trek from Malavli station leads to these serene and spiritually charged locations. It's a hidden delight for history lovers, archaeologists, and those seeking quietude in nature."
  },
  {
    "title": "Kune Falls",
    "location": "Khandala Valley, Pune District, Maharashtra",
    "description": "Kune Falls is a three-tiered waterfall nestled between Lonavala and Khandala and is one of the highest waterfalls in Maharashtra at a height of about 200 meters. Surrounded by lush forested hills and colonial-era homes, the falls come alive during the monsoon season. It is a favorite stop for nature lovers, photographers, and those wanting to experience the raw power of nature. The backdrop of the Sahyadri range enhances the scenic beauty, making it a must-visit during the rains."
  },
  {
    "title": "Pawna Lake & Dam",
    "location": "Mawal Taluka, Near Khandala, Maharashtra",
    "description": "Pawna Lake is a manmade reservoir formed by the Pavana Dam and is one of the best camping and picnic destinations near Khandala. It offers tranquil lakeside views, boating opportunities, and ample spots for pitching a tent. With the Sahyadri mountains in the background and forts like Lohagad, Tikona, and Tung nearby, the area is rich in both natural and historical beauty. Many travelers opt for overnight camping with bonfires under a starlit sky."
  },
  {
    "title": "Reversing Station Viewpoint",
    "location": "Khandala Ghat Section, Maharashtra",
    "description": "An engineering marvel from the British era, the Reversing Station once served as a crucial point on the Mumbai–Pune railway. Today, it’s a scenic viewpoint that offers breathtaking views of the curving rail tracks, Bhor Ghat valley, and the city lights of Khopoli at night. It’s a lesser-known gem for those interested in railway history and hill photography. The area is calm, secluded, and perfect for peaceful observation."
  },
  {
    "title": "Tamhini Ghat",
    "location": "Near Khandala, Maharashtra",
    "description": "Tamhini Ghat is a spectacular mountain pass located close to Khandala, known for its mist-covered roads, dense forests, waterfalls, and cool breeze during monsoon. The drive through this ghat is a sensory delight—ideal for long bike rides or weekend car trips. Stop anywhere along the way to witness spontaneous waterfalls and panoramic landscapes. It’s a nature photographer’s paradise and a favorite for road trip lovers."
  }
],



"services": [
    {
        "name": "Mumbai to Khandala Taxi Fare",
        "description": "Our Mumbai to Khandala taxi fare offers transparent and competitive pricing designed to give you the best value for your journey. Whether you're traveling for a weekend getaway or a business trip, our fare structure is straightforward with no hidden charges, ensuring peace of mind. We cater to various vehicle types and travel preferences, helping you find the perfect fit for your needs while maintaining affordability and comfort throughout your ride."
    },
    {
        "name": "Cab Fare from Mumbai to Khandala",
        "description": "Get accurate and reliable cab fare estimates for your Mumbai to Khandala journey. We provide detailed fare information upfront, so you know exactly what to expect before you book. Our pricing is crafted to accommodate different budgets and vehicle options, from economical hatchbacks to spacious SUVs, allowing you to choose the ideal ride. Enjoy a hassle-free experience with no surprises, backed by transparent billing and excellent customer support."
    },
    {
        "name": "One Way Taxi Fare Mumbai to Khandala",
        "description": "Our affordable one-way taxi fare from Mumbai to Khandala is perfect for travelers who need a direct, no-frills trip without additional costs for return journeys. Whether you’re visiting Khandala for a day trip or heading there for business, our one-way fares are designed to maximize convenience and value. Choose from a range of comfortable vehicles, all driven by professional chauffeurs who prioritize your safety and timely arrival."
    },
    {
        "name": "Round Trip Khandala Cab Fare",
        "description": "Planning a round trip from Mumbai to Khandala? Benefit from our cost-effective round trip cab fares which are tailored to offer maximum savings and flexibility. Our round-trip packages include both onward and return journeys, allowing you to relax and enjoy your time in Khandala without worrying about transport. Our vehicles are well-maintained and driven by experienced drivers familiar with the route, ensuring a smooth and comfortable ride throughout."
    },
    {
        "name": "Affordable Khandala Cab Fare Mumbai",
        "description": "Experience budget-friendly yet reliable taxi fares from Mumbai to Khandala that do not compromise on comfort or service quality. Ideal for families, solo travelers, and small groups, our affordable fares make exploring Khandala accessible to everyone. We provide clean, air-conditioned vehicles and skilled drivers to make your journey safe and enjoyable. Enjoy competitive rates combined with transparent pricing to keep your travel expenses in check."
    },
    {
        "name": "Luxury Cab Fare to Khandala",
        "description": "Indulge in a premium travel experience with our luxury cab fares from Mumbai to Khandala. Perfect for special occasions, corporate travel, or those who prefer extra comfort and style, our luxury vehicles come equipped with high-end amenities. From plush interiors to professional chauffeurs, every aspect of your ride is crafted to provide a first-class experience. Our luxury fare options give you the exclusivity and convenience that make your journey truly memorable."
    },
    {
        "name": "AC Taxi Fare Mumbai to Khandala",
        "description": "Travel comfortably with our air-conditioned taxi fares from Mumbai to Khandala, ensuring a pleasant and cool ride even during the hottest months. Our AC taxis are well-maintained and sanitized, offering a safe environment for you and your companions. Ideal for families, couples, or business travelers who value comfort, our AC fare options combine affordability with quality service, so you arrive refreshed and relaxed at your destination."
    },
    {
        "name": "SUV Fare to Khandala from Mumbai",
        "description": "Our competitive SUV taxi fares from Mumbai to Khandala are designed for larger groups or travelers seeking extra space and comfort. SUVs provide ample legroom and luggage capacity, making them perfect for family outings, group tours, or those carrying extra baggage. Our drivers are experienced in highway travel, ensuring a smooth ride through scenic routes. Enjoy the benefits of both luxury and practicality with our SUV fare options."
    },
    {
        "name": "Budget Taxi Fare Mumbai to Khandala",
        "description": "For travelers mindful of expenses, our budget taxi fare from Mumbai to Khandala offers an economical travel solution without sacrificing reliability or safety. Perfect for students, solo travelers, and budget-conscious families, this option provides clean and efficient vehicles at reasonable prices. Despite being budget-friendly, we maintain high standards for vehicle upkeep and driver professionalism to ensure a worry-free journey."
    },
    {
        "name": "Online Fare Mumbai to Khandala Taxi",
        "description": "Easily calculate your taxi fare from Mumbai to Khandala online with our user-friendly fare calculator. This tool provides instant fare estimates based on your vehicle choice, travel dates, and trip type, allowing you to plan your budget with confidence. Our online platform also facilitates seamless booking and payment, ensuring a smooth process from start to finish. Enjoy the convenience of managing your trip digitally with clear, upfront pricing."
    },
    {
        "name": "Book Mumbai to Khandala Cab Fare",
        "description": "Booking your Mumbai to Khandala taxi fare is now easier than ever with our transparent pricing and instant online confirmation. Simply choose your preferred vehicle, check the fare, and reserve your cab with a few clicks. Our booking system is designed for convenience, ensuring that you receive a confirmed cab at the quoted fare without any last-minute price changes. Trust us for punctual pickups, professional drivers, and a comfortable ride."
    },
    {
        "name": "Chauffeur-driven Cab Fare Khandala",
        "description": "Travel in style and safety with our chauffeur-driven taxi fares from Mumbai to Khandala. Our professional drivers are highly trained, courteous, and knowledgeable about the best routes to get you there on time. Perfect for those who want a stress-free journey, our chauffeur service combines luxury with affordability. Experience personalized service and door-to-door convenience for all your trips to Khandala."
    }
],

"tableData": [
    ["Mumbai to Khandala Taxi Fare", "-Cab Fare from Mumbai to Khandala"],
    ["One Way Taxi Fare Mumbai to Khandala", "-Round Trip Khandala Cab Fare"],
    ["Affordable Khandala Cab Fare Mumbai", "-Luxury Cab Fare to Khandala"],
    ["AC Taxi Fare Mumbai to Khandala", "-SUV Fare to Khandala from Mumbai"],
    ["Budget Taxi Fare Mumbai to Khandala", "-Online Fare Mumbai to Khandala Taxi"],
    ["Book Mumbai to Khandala Cab Fare", "-Chauffeur-driven Cab Fare Khandala"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Pickup from Mumbai",
    "WhyChoosedescription": "Deva Cabs values your time. That’s why we offer prompt, on-time pickups from anywhere in Mumbai for your trip to Khandala. Whether you're planning an early morning start or a late-night departure, our drivers arrive punctually so you never have to wait. With real-time tracking and trip updates, you can rest assured your journey begins smoothly and on schedule."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Taxis",
    "WhyChoosedescription": "Traveling from Mumbai to Khandala should be as relaxing as the destination itself. Our fleet includes sedans, SUVs, and premium cars—each maintained to the highest standards of cleanliness and comfort. Enjoy a smooth ride with air-conditioning, spacious legroom, ergonomic seating, and plenty of luggage space. Whether you’re traveling solo, with family, or in a group, we have a vehicle that fits your needs perfectly."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Scenic Mountain Routes",
    "WhyChoosedescription": "Our drivers are experts when it comes to the Mumbai–Pune Expressway and the winding roads leading to Khandala. Trained in defensive driving and well-versed in the region’s terrain and traffic patterns, they ensure a safe and pleasant journey. They’ll even suggest scenic spots or food stops if you’d like to take a break and enjoy the view."
  },
  {
    "WhyChooseheading": "Fair and Transparent Fare Structure",
    "WhyChoosedescription": "Say goodbye to hidden charges and unpredictable pricing. With Deva Cabs, you get a clear fare estimate before you confirm your booking. Our Mumbai to Khandala taxi rates are competitive and fully transparent—no last-minute surprises, no surge pricing, and no extra fees for luggage or tolls. Just honest, upfront pricing that respects your budget."
  },
  {
    "WhyChooseheading": "24/7 Availability for Outstation Trips",
    "WhyChoosedescription": "We understand that travel plans don’t always follow a 9-to-5 schedule. That’s why our Mumbai to Khandala taxi services operate round the clock. Whether you're heading out for a sunrise trek, returning from a weekend stay, or making an impromptu night drive, you can rely on Deva Cabs to be available when you need us most."
  },
  {
    "WhyChooseheading": "Safety First for Every Passenger",
    "WhyChoosedescription": "Your safety is our top priority. All Deva Cabs are equipped with real-time GPS tracking, airbags, safety belts, and speed governors. We conduct regular vehicle inspections and ensure that each cab is thoroughly sanitized before every trip. Our drivers follow all traffic rules and undergo background verification, giving you peace of mind every time you ride with us."
  },
  {
    "WhyChooseheading": "Quick Booking with Real-Time Updates",
    "WhyChoosedescription": "Booking your ride from Mumbai to Khandala is quick and hassle-free with our easy-to-use mobile app and website. Within a few taps, you’ll have a confirmed cab at your doorstep. Track your driver live, get real-time ETA updates, and receive prompt notifications. Need help? Our dedicated support team is just a call away, ready to assist you at any point during your journey."
  },
  {
    "WhyChooseheading": "Custom Travel Plans for Weekend Getaways",
    "WhyChoosedescription": "Khandala is a top choice for short breaks and scenic escapes. That’s why Deva Cabs offers flexible packages tailored to your travel style. Choose from one-way trips, round trips, or hourly rentals for sightseeing and leisure. Planning to stop at Lonavala or visit nearby attractions like Rajmachi Fort or Bushi Dam? Just let us know—we’ll customize the route to fit your itinerary, making your getaway even more memorable."
  }
]










    }




const faqData = [
  {
    question: "What is the fare for a taxi from Mumbai to Khandala?",
    answer: "The fare for a taxi from Mumbai to Khandala depends on the type of vehicle you choose. You can check the estimated fare using our website or mobile app, or contact customer support for an accurate quote."
  },
  {
    question: "What vehicle options are available for the Mumbai to Khandala trip?",
    answer: "We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel preferences and group size for a comfortable ride from Mumbai to Khandala."
  },
  {
    question: "How long does the journey from Mumbai to Khandala take?",
    answer: "The journey from Mumbai to Khandala typically takes around 2 to 3 hours depending on the traffic and road conditions."
  },
  {
    question: "Is there a round trip option for the Mumbai to Khandala taxi ride?",
    answer: "Yes, you can book a round-trip taxi for your journey to Khandala. We ensure timely pick-up and drop-off based on your preferred schedule."
  },
  {
    question: "Can I pre-schedule my taxi ride from Mumbai to Khandala?",
    answer: "Yes, you can pre-schedule your taxi ride from Mumbai to Khandala through our booking portal or mobile app. Choose your preferred date and time for guaranteed pick-up."
  },
  {
    question: "What are the payment options for the Mumbai to Khandala taxi ride?",
    answer: "We accept cash, credit/debit cards, UPI, and online payments through our mobile app or website for your Mumbai to Khandala ride."
  },
  {
    question: "Are the drivers experienced for the Mumbai to Khandala taxi ride?",
    answer: "Yes, all our drivers are experienced, verified, and familiar with the Mumbai to Khandala route to ensure a safe and smooth journey."
  },
  {
    question: "Is it safe to travel from Mumbai to Khandala with Deva Cabs?",
    answer: "Absolutely! All our taxis are GPS-enabled, and we ensure the highest safety standards with professional drivers who prioritize your comfort and security."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Anil Mehta',
    role: 'Frequent Traveler',
    review: 'I travel to Khandala often for weekend getaways. Deva Cabs offers great service with competitive fares. The drivers are professional, and the ride is always smooth.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Neha Joshi',
    role: 'Tourist',
    review: 'Took a taxi from Mumbai to Khandala with Deva Cabs for a quick trip. The car was clean, the driver was friendly, and the ride was comfortable. Highly recommend for a scenic drive!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Khandala Taxi Fare",
  "image": "https://devacab.com/assets/images/mumbai-to-khandala-taxi.jpg", // Replace with actual image URL
  "description": "Transparent and affordable Mumbai to Khandala taxi fare by Deva Cabs. Book one-way or round trip cabs with options including AC cars, SUVs, luxury vehicles, and chauffeur-driven services. Ideal for weekend getaways and family travel.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800", // Example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-khandala-taxi-fare" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Khandala Taxi Fare | Affordable Cab Fare Mumbai to Khandala | Deva Cabs</title>
  <meta
    name="description"
    content="Check affordable and transparent Mumbai to Khandala taxi fare with Deva Cabs. One-way and round trip pricing for AC, SUV, luxury, and budget cabs. Book online for weekend trips or family travel."
  />
  <meta
    name="keywords"
    content="Mumbai to Khandala Taxi Fare, Cab fare from Mumbai to Khandala, One way taxi fare Mumbai to Khandala, Round trip Khandala cab fare, Affordable Khandala cab fare Mumbai, Luxury cab fare to Khandala, AC taxi fare Mumbai to Khandala, SUV fare to Khandala from Mumbai, Budget taxi fare Mumbai to Khandala, Online fare Mumbai to Khandala taxi, Book Mumbai to Khandala cab fare, Chauffeur-driven cab fare Khandala"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/68.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitokhandalataxi;